import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Button from '@components/common/Button';
import LeftNavBar from '../../AppWrapperViewComponent/LeftNavBar';
import BadgesComponent from '@components/common/Badges';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import NationalEmblem from './../../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from './../../../assets/svg_main/BackArrowIconSvg.svg';
import '../../AppWrapperComponent.css';
import './overViewLayout.css';
import endpoints from '@config/endpoints';
import axios from '@utils/axiosExt';
import Auth from '@utils/auth';
import { useDispatch, useSelector } from 'react-redux';
import { setCreateMapPincodeWithHfr, setGeometryMapPoint, setMapLatLong, setMapManualAddress, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setMapServicesDown } from '@store/actions/facilityGeoMapAction';

import { errorLogger } from '@utils/applicationLogUtils';
import ApprovalHealthFacilityUpdate from '../HealthFacility/Update/HealthFacilityUpdate';
import HealthFacilityOverview from '../HealthFacility/Overview/HealthFacilityOverview';
import { RootState } from '@store/reducers';
import { STATUS, approvalConstantData, errorSuccessMessage } from '@constants/approvalConstants';
import { setApprovalPageType, setApprovalRequestData, setComments } from '@store/actions/approvalActions';
import HealthProviderOverview from '../HealthProvider/Overview/HealthProviderOverview';
import ShiftTransferComponent from '../HealthProvider/Update/ShiftTransferComponent';

interface HealthFComponentProps {
  page: string;
  flow: string;
}
interface facilityTypeProps {
  [key: string]: any;
}

const TABS = ['Overview'];
const ApprovalHealthFacilityView = (props: HealthFComponentProps) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { page } = props;
  const navigate = useNavigate();
  const approvalLayout = useSelector((state: RootState) => state.approvalWorkFlow);
  const [facility, setFacility] = useState<facilityTypeProps | null>(null);
  const [requestData, setRequestData] = useState<any>([]);
  const [healthProvideUserData, setHealthProvideUserData] = useState<any>(null);
  const [approvalData, setApprovalData] = useState<facilityTypeProps | null>(null);
  const [currentTab, setCurrentTab] = useState('Overview');
  const [showLoader, setShowLoader] = useState<boolean>(true);

  const clearMapStore = () => {
    dispatch(setGeometryMapPoint({ mapPointer: '', distFenceGeometry: '' }));
    dispatch(setMapManualAddress(false));
    dispatch(setMapLatLong(null));
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
    dispatch(setMapPincodeFirstTimeEdit(null));
    dispatch(setCreateMapPincodeWithHfr(null))
    dispatch(setMapServicesDown(false));
  };
  const clearRedux = () => {
    dispatch(setComments(''));
    dispatch(setApprovalPageType(approvalConstantData.pageType.view));
    dispatch(setApprovalRequestData({
      requestFor: '',
      requestTrxnId: '',
      requestType: '',
      requestTypeCode: '',
      requestStatus: '',
      requestResubmited: false,
      dataModificationTrackerId: '',
      requestComments: ''
    }));
  }

  const getApprovalRequestDetails = async () => {
    try {
      setShowLoader(true);

      const requestId =  approvalLayout.requestData.requestTrxnId;
      const approvalResponse = await axios.get(`${endpoints.getApprovalRequestDetails(requestId)}`, Auth.loggedIn());
      if (approvalResponse && approvalResponse.data) {
        const approvalData = approvalResponse.data.data;
        if (approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_provider) {
          setHealthProvideUserData(approvalData[0]?.current_data?.user_details?.[0])
        }
        setRequestData(approvalData);
        setApprovalData(approvalData);
        setShowLoader(false);
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
      setShowLoader(true);
    }
  };

  useEffect(() => {
    setShowLoader(true);
    getApprovalRequestDetails();
  }, [id]);

  const getStatusMessage = () => {
    const status: any = approvalLayout.requestData.requestStatus;

    switch (status) {
      case STATUS.REJECTED:
        return {
          message: errorSuccessMessage.rejectStatus,
          className: 'rejected',
        };
      case STATUS.NO_ACTION:
        return {
          message: errorSuccessMessage.noActionStatus,
          className: 'no-action',
        };
      default:
        return null;
    }
  };

  const statusMessage = getStatusMessage();

  const getBadgeData = () => {
    if ((approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_provider)) {
      return healthProvideUserData?.user_status || '-';
    }
    else if(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_facility){
      return approvalData?.[0]?.current_data?.[0]?.facility_info?.facility_details?.[0]?.status_name || '-';
    }
  };

  const getBadgeVariant = () => {
  const reqType = approvalLayout.requestData.requestType;
  switch (reqType) {
    case approvalConstantData.requestType.health_facility: {
      const statusName = approvalData?.[0]?.current_data?.[0]?.facility_info?.facility_details?.[0]?.status_name;
      if (statusName === 'Inactive' || approvalData?.[0]?.current_data?.[0]?.facility_info?.facility_details?.[0]?.status_name === 'Permanently Closed') {
        return 'warning';
      }
      return 'success';
    }
    case approvalConstantData.requestType.health_provider:
      return 'success';
    default:
      return 'success';
  }
};

  const badgeData = getBadgeData();

  const handleUpdateCancle = () => {
    dispatch(setApprovalPageType(approvalConstantData.pageType.view));
    dispatch(setComments(''));
  }

  return (
    <div className="app-view-wrapper health_facility">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: page, label: 'Health Requests' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <Button
              onClick={() => {
                clearMapStore();
                clearRedux();
                navigate(`/approvals-flow`)
              }}
              disabled={false}
              id=""
              buttonName={''}
              colorType={'verticalbackbutton'}
              icon={<BackArrowsvg />}
              iconPosition={'left'}
            />
            <div className="name-type facility">
              {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_provider) && <div className="name">
                <div style={{ textTransform: 'capitalize' }}>{healthProvideUserData?.user_name || '-'}</div>
                <div className='userTypeText'>{healthProvideUserData?.user_type || '-'} {' > '} {healthProvideUserData?.user_designation || '-'}</div>
              </div>}
              {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_facility) && <div className="type ribbon-facility-name">{approvalData && approvalData[0]?.current_data?.[0]?.facility_info?.facility_details?.[0]?.facility_name}</div>}
              <div className='status-badge'>
                <BadgesComponent
                  className="over-badge"
                  badgeName={badgeData}
                  variant={getBadgeVariant()}
                  badgeType="case5"
                />
              </div>
            </div>
          </div>
        </div>
        <div className='content'>
          <LeftNavBar
            navItems={TABS}
            currentTab={currentTab}
            handleNavClick={setCurrentTab}
          />
          <div className='tab-content'>
            {!showLoader ? <>
              {(statusMessage && approvalLayout.requestData.requestFor === approvalConstantData.requestFor.sent && approvalLayout.pageType == approvalConstantData.pageType.view && !approvalLayout.requestData.requestResubmited) && (
                <div
                  className={`approval-overview-status-message ${statusMessage.className}`}
                >
                  {statusMessage.message}
                </div>
              )}
              {approvalLayout.pageType == approvalConstantData.pageType.view &&
                <>
                  {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_facility) && <HealthFacilityOverview facility={approvalData} />}
                  {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_provider) && <HealthProviderOverview healthProviderData={approvalData} />}
                </>

              }
              {approvalLayout.pageType == approvalConstantData.pageType.edit &&
                <>
                  {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_facility) && <ApprovalHealthFacilityUpdate healthFacility={approvalData} />}
                  {(approvalLayout.requestData.requestType && approvalLayout.requestData.requestType == approvalConstantData.requestType.health_provider) && <ShiftTransferComponent healthProviderData={requestData[0]} onCancel={() => { handleUpdateCancle() }} />}
                </>
              }
            </> : <div className='loader'>Loading...</div>}
          </div>
        </div>
      </main>
    </div>
  );
}
ApprovalHealthFacilityView.displayName = 'ApprovalHealthFacilityView';
export default ApprovalHealthFacilityView;  